export function getPageNumForTitle(pageNum: number, lang: string): string {
    if (pageNum > 1) {
        return lang === 'ru' ? `- Страница ${pageNum}` : `- Сторінка ${pageNum}`;
    }
    return '';
}